import React from 'react';
import PropTypes from 'prop-types';

Problem.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  description: PropTypes.string,
  alt: PropTypes.string,
  answer: PropTypes.string.isRequired,
};

export default function Problem({ title, image, alt, description, answer }) {
  return (
    <section className="bg-lightblue">
      <article className="problem-main ">
        <div className="problem-container">
          <aside className="problem-left">
            <div className="problem-top">
              <h2 className="underlined-heading">THE PROBLEM</h2>
              <p className="problem-title">{title}</p>
            </div>
            {description && (
              <p className="problem-description">{description}</p>
            )}
          </aside>
          <img
            className="problem-image"
            src={image}
            alt={alt || 'problem image'}
          />
        </div>
        <div className="problem-answer">{answer}</div>
      </article>
    </section>
  );
}
